import { render } from "./status-details-popup.vue?vue&type=template&id=66a94866&scoped=true"
import script from "./status-details-popup.vue?vue&type=script&lang=js"
export * from "./status-details-popup.vue?vue&type=script&lang=js"

import "./status-details-popup.vue?vue&type=style&index=0&id=66a94866&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a94866"]])

export default __exports__